import { createAction, props } from '@ngrx/store'
import { Office } from './office.state'

// Action to load Office
export const loadOffices = createAction(
  '[Office] Load Offices',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful business load
export const loadOfficesSuccess = createAction(
  '[Office] Load Office Success',
  props<{
    totalCount: number
    offices: Office[]
  }>()
)

// Action for business load failure
export const loadOfficesFailure = createAction(
  '[Office] Load Office Failure',
  props<{ error: string }>()
)

export const loadOfficeCounts = createAction('[Office] Load Counts')
export const setOfficeCounts = createAction('[Office] Set Counts', props<{ totalCount: number }>())

export const createOffice = createAction(
  '[Office] Create Office',
  props<{
    officeName: string
    businessId: string
    address?: string
    cityId?: number
    zipCode?: string
    latitude?: number
    longitude?: number
    radiusM?: number
  }>()
)

export const createOfficeSuccess = createAction(
  '[Office] Create Office Success',
  props<{ office: Office }>()
)

export const createOfficeFailure = createAction(
  '[Office] Create Office Failure',
  props<{ error: any }>()
)

export const updateOffice = createAction(
  '[Business] Update Office',
  props<{
    id: string
    officeName: string
    address: string
    cityId: number
    zipCode: string
    latitude?: number
    longitude?: number
    radiusM?: number
  }>()
)

export const updateOfficeSuccess = createAction(
  '[Office] Update Office Success',
  props<{ office: Office }>()
)

export const updateOfficeFailure = createAction(
  '[Office] Update Office Failure',
  props<{ error: any }>()
)

export const resetOfficeState = createAction('[Office] Reset state')
